<table class="table table-striped ">
    <tr app-session-list-row *ngFor="let o of this.service.sidToTokenObject | keyvalue" [tokenObject]="o.value">
    </tr>


</table>